module.exports = "//public.getcloudapp.com/packs/media/images/annotate/tools-zoom-zoom-in-602e8a4914fd9a4076c6ed2694fdc101.svg";